import React from 'react';
import { filterProps } from '../filter-props';
// import { Props } from '../custom/types';
import { BaseBlok, BlokToComponentProps } from '../blok-to-component/types';
import { StringService } from '../../services/string';
import { slottedToComponents } from '../slotted-to-components';

export const StencilComponentBuilder = ({
  getComponent,
  blok,
  slot,
  storyId,
}: BlokToComponentProps<BaseBlok>): JSX.Element => {
  const { props, slotted } = filterProps(blok);
  const allProps = {
    ...props,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok._uid ? { uid: blok._uid } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok.id || blok._uid ? { id: blok.id || blok._uid } : {}),
    storyId,
  };

  // Handle Storyblok API bug where a Content Entry type can loose it's type
  if (!blok.component) {
    return <></>;
  }

  const CustomComponent = StringService.camelToKebab(blok.component) as React.ElementType;
  const children = slottedToComponents(getComponent, slotted, storyId);
  return <CustomComponent {...allProps}>{children}</CustomComponent>;
};
